export function searchFilterTransactions(
  transactions,
  searchTerm,
  typeFilter = "All",
  statusFilter = "All"
) {
  if (!Array.isArray(transactions) || transactions.length === 0) return [];

  const term = (searchTerm || "")
    .replace(/[^a-zA-Z0-9\s\-_.@]/g, "")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();

  return transactions.filter((txn) => {
    const matchesSearch =
      !term ||
      txn.transactionNumber?.toLowerCase().includes(term) ||
      txn.id?.toLowerCase().includes(term) ||
      txn.customer?.name?.toLowerCase().includes(term) ||
      txn.cashier?.toLowerCase().includes(term);

    const matchesType =
      typeFilter === "All" || txn.type?.toLowerCase() === typeFilter.toLowerCase();

    const matchesStatus =
      statusFilter === "All" || txn.status?.toLowerCase() === statusFilter.toLowerCase();

    return matchesSearch && matchesType && matchesStatus;
  });
}
